
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MapPin } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useState } from "react";

interface LocationPromptDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onEnableLocation: () => void;
  onMaybeLater: () => void;
  onDoNotShowAgain?: (value: boolean) => void;
}

export const LocationPromptDialog = ({
  open,
  onOpenChange,
  onEnableLocation,
  onMaybeLater,
  onDoNotShowAgain
}: LocationPromptDialogProps) => {
  const [doNotShow, setDoNotShow] = useState(false);
  
  const handleMaybeLater = () => {
    if (doNotShow && onDoNotShowAgain) {
      onDoNotShowAgain(true);
    }
    onMaybeLater();
  };
  
  const handleEnableLocation = () => {
    onEnableLocation();
  };
  
  const handleCheckboxChange = (checked: boolean) => {
    setDoNotShow(checked);
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto p-3 rounded-full bg-primary/10 mb-4">
            <MapPin className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center">Enable Location Services</DialogTitle>
          <DialogDescription className="text-center">
            Get the most out of HomePlate by enabling location services
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="h-4 w-4 text-primary" />
              <span>See exact delivery times</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="h-4 w-4 text-primary" />
              <span>Find meals near you</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="h-4 w-4 text-primary" />
              <span>Get accurate delivery fees</span>
            </div>
          </div>

          {onDoNotShowAgain && (
            <div className="flex items-center space-x-2 pt-2">
              <Checkbox 
                id="do-not-show" 
                checked={doNotShow} 
                onCheckedChange={handleCheckboxChange} 
              />
              <label 
                htmlFor="do-not-show" 
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Don't ask again
              </label>
            </div>
          )}

          <div className="flex flex-col gap-2">
            <Button onClick={handleEnableLocation}>
              Enable Location
            </Button>
            <Button variant="outline" onClick={handleMaybeLater}>
              Maybe Later
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
